export interface IUserState {
  userId: number | null;
  anonymousUserId: string | null;
}

const initialState: IUserState = {
  userId: null,
  anonymousUserId: null,
};

export function userReducer(state: IUserState = initialState) {
  return state;
}
